import React from 'react';

export default function TextNormal({ children }) {
  return <div class='font-[NotoSansKR]'>{children}</div>;
}
